import { call, select, put } from 'redux-saga/effects';
import { showErrorToast } from '../actions/app-actions-types';
import { showLoader, hideLoader, setServerDown } from '../actions/app-actions-types';
import getAxiosInstance from '../utilities/axiosInstance';
import Idx from 'idx';
import I18n from '../utilities/locale';
import { logout } from '../actions/user-actions-types';
import Connection from '../utilities/Connection';
const isReleaseBuild = process.env.NODE_ENV === 'production';

function* HttpClient(payload, isLoader = true) {
  const authToken = yield select(({ user: { token } }) => token);
  const {
    type = '',
    isCloudFrontURL = false,
    showHttpClientError = true,
    noCache = false
    // url = ''
  } = payload;
  if (isLoader) {
    yield put(showLoader());
  }
  let random = '';
  if (!isReleaseBuild) {
    random = btoa(Math.random().toString()).substr(10, 3);
    const baseURL = Connection.getBaseUrl(isCloudFrontURL);
    if (!window?.ReactNativeWebView) {
      console.log(`%c------ payload------ ${random} -- `, 'color: orange; font-size:10px', {
        ...payload,
        baseURL
      });
    }
  }

  const axiosInstance = getAxiosInstance({ authToken, isCloudFrontURL, noCache });

  try {
    const { data: result } = yield call(axiosInstance, payload);
    if (isLoader) yield put(hideLoader());
    if (!isReleaseBuild) {
      if (!window?.ReactNativeWebView) {
        console.log(`%c------ result ------ ${random} -- `, 'color: green; font-size:10px', result);
      }
    }

    return {
      error: null,
      result
    };
  } catch (error) {
    const errorObj = error['error'] !== undefined ? error['error'] : error;
    let { message = '' } = errorObj;
    const { statusCode = 0, status, details = [], httpCode = 0 } = errorObj;

    if (!isReleaseBuild) {
      if (!window?.ReactNativeWebView) {
        console.log(`%c------ error ------ ${random} -- `, 'color: red; font-size:10px', errorObj);
      }
    }

    if (isLoader) yield put(hideLoader());

    if (!showHttpClientError) {
      return {
        result: null,
        error: errorObj
      };
    }

    if (Idx(error, (_) => _.code)) {
      if (error.code === 'ECONNABORTED') {
        yield put(showErrorToast(I18n.t('InternetMessage')));
      }
    } else if (error && statusCode === 404) {
      if (!isReleaseBuild) console.log('404');
    } else if (
      error &&
      statusCode === 401 &&
      (message === 'access denied, token revoked.' || message === 'invalid login credentials') &&
      (type !== 'login' || type !== 'phoneLogin' || type !== 'sendMobileOTP')
    ) {
      yield put(showErrorToast(I18n.t('sessionExpiredPleaseLoginAgain')));
      yield put(logout());
    } else if (
      error &&
      (statusCode === 502 || statusCode === 503 || status === 503 || status === 502)
    ) {
      yield put(setServerDown(true));
      yield put(showErrorToast(I18n.t('ServiceTemporarilyUnavailable')));
    } else if (Idx(error, (_) => _.statusCode) || Idx(errorObj, (_) => _.statusCode)) {
      if (details.length > 0) {
        message = details[0].message;
      }
      if (type === 'phoneRegister' && message.includes('duplicate key error collection')) {
        yield put(showErrorToast(I18n.t('alreadyRegisteredWithPhoneNumber')));
      } else if (type === 'pancard' && message.includes('duplicate key error collection')) {
        yield put(showErrorToast('Pancard is already associated with other account'));
      } else if (type === 'bank_account' && message.includes('duplicate key error collection')) {
        yield put(showErrorToast('Bank Account is already associated with other account'));
      } else if (type === 'sendMobileOTP' && message.includes('authentication unsuccessful.')) {
        yield put(showErrorToast(I18n.t('notRegisteredMsg')));
      } else if (type === 'addEmail' && message.includes('duplicate key error collection')) {
        yield put(showErrorToast('This email is already associated with other account'));
        // eslint-disable-next-line no-empty
      } else if (message.includes('Internal Server Error')) {
      } else yield put(showErrorToast(message));
    } else if (httpCode === 429) {
      yield put(showErrorToast(I18n.t('rateLimitMsg')));
    } else if (error) {
      const { request = {} } = error;
      let { _response = '' } = request;
      if (_response.includes('No address associated with hostname'))
        yield put(showErrorToast(I18n.t('InternetMessage')));
      // else if (_response) yield put(showErrorToast(_response))
      else if (navigator.onLine) yield put(showErrorToast(I18n.t('SomethingWentWrong')));
    }
    return {
      result: null,
      error: errorObj
    };
  }
}

export default HttpClient;
